module.exports = __webpack_public_path__ + "img/submit.ce5b2e1d.png";